import { useFormik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { editCoursePurchase, getSingleCoursePurchase } from "../../redux/services/coursePurchaseSlice";
import { ROUTES } from "../../constant";

const CoursePurchaseForm = ({ action }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const singlePurchase = useSelector((state) => state.coursePurchase.singleCoursePurchase);
  const queryParams = new URLSearchParams(location.search);
  const purchaseId = queryParams.get("purchaseId");
  const [loading, setLoading] = useState(false);

  const initialValues = {
    purchaseId: "",
    status: "",
    paymentId: "",
  };

  const validationSchema = Yup.object({
    status: Yup.string().required("Status is required"),
    paymentId: Yup.string().required("Payment ID is required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      if (purchaseId) values.purchaseId = purchaseId;
      const response = await dispatch(editCoursePurchase(values));

      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        navigate(ROUTES.COURSES.PURCHASE);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setValues } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const getSingleRecord = useCallback(async () => {
    try {
      await dispatch(getSingleCoursePurchase(purchaseId));
    } catch (error) {}
  }, [dispatch, purchaseId]);

  useEffect(() => {
    if (purchaseId) getSingleRecord();
  }, [purchaseId, getSingleRecord]);

  useEffect(() => {
    if (purchaseId && singlePurchase) {
      setValues({
        purchaseId: singlePurchase?._id ?? "",
        status: singlePurchase?.status ?? "",
        paymentId: singlePurchase?.paymentId ?? "",
      });
    }
  }, [purchaseId, singlePurchase, setValues]);

  return (
    <div>
      <div className="bg-background py-4 sm:py-4">
        <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
          <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">{action} Course Purchase</p>
          <form className="mt-6" onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              {/* [PENDING, COMPLETED, FAILED] */}
              <div className="md:col-span-2">
                <label className="text-sm font-medium text-foreground">Status</label>
                <select name="status" className="w-full px-4 py-2 border border-border rounded-xl" value={values.status} onChange={handleChange}>
                  {["PENDING", "COMPLETED", "FAILED"]?.map((s, i) => (
                    <option key={i} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
                {touched.status && errors.status && <div className="text-red-500 text-sm">{errors.status}</div>}
              </div>

              <div className="md:col-span-2">
                <label className="text-sm font-medium text-foreground">Payment ID</label>
                <input type="text" name="paymentId" className="w-full px-4 py-2 border border-border rounded-xl bg-card" value={values.paymentId} onChange={handleChange} onBlur={handleBlur} placeholder="Enter Payment ID" />
                {touched.paymentId && errors.paymentId && <div className="text-red-500 text-sm">{errors.paymentId}</div>}
              </div>
            </div>
            <div className="flex justify-center">
              <button type="submit" className="w-full sm:w-[250px] min-h-[50px] flex justify-center items-center text-white bg-primary text-lg font-semibold rounded-xl hover:bg-accent mt-7">
                {loading ? <div className="loader"></div> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CoursePurchaseForm;
